import { Component } from '@angular/core';
import { baseStyle, iconTypes, iconWeights } from 'msteams-ui-icons-core';
import { Colors, IContext, getContext, ThemeStyle, primaryButton, surface } from 'msteams-ui-styles-core'
import { style } from 'typestyle/lib'
import { MsTeamsContextProvider } from './core/providers/msteamscontext.provider';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  title = 'app';
  context: IContext;

  cssSurface: string;

  constructor(
    private _msTeamsContextProvider: MsTeamsContextProvider,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    //this.spinner.show();

    //setTimeout(() => {
    //  /** spinner ends after 5 seconds */
    //  this.spinner.hide();
    //}, 5000);

    var context = this._msTeamsContextProvider.getContext();

    this.cssSurface = surface(context);

    
  }
}
